import { IPricingSubscription } from './types';

export const API_RESPONSE_SUCCESS = 'SUCCESS';
export const API_RESPONSE_FAIL = 'FAIL';

export enum PricingSubscriptionType {
  Gold = 'Gold',
  Platinum = 'Platinum',
  Diamond = 'Diamond',
  Invest = 'Invest'
}

export enum PricingSubscriptionResult {
  Success = 'Success',
  InsufficientFund = 'InsufficientFund',
  SubscribeFailure = 'SubscribeFailure'
}

export const DEFAULT_SUBSCRIPTION_INVEST: IPricingSubscription = {
  currentSubscription: PricingSubscriptionType.Invest,
  currentSubscriptionEndDate: '',
  nextSubscription: PricingSubscriptionType.Invest,
  eligibleTypesToSubscribe: [PricingSubscriptionType.Diamond, PricingSubscriptionType.Platinum]
};
